import { cva } from "class-variance-authority";

export const tableVariants = cva("table-auto border-collapse rounded-lg md:table-fixed");

export const HeaderVariants = cva("p-4 text-left font-medium", {
  variants: {
    variant: {
      userTable: "bg-primary text-foreground",
      AmbaTable: "bg-primary text-foreground",
      AdminTable: "bg-primary text-foreground",
    },
  },
  defaultVariants: {
    variant: "AdminTable",
  },
});
